import { ExternalLink } from 'components/elements/ExternalLink';
import { Label } from 'components/elements/Label';
import { InfoModal } from 'components/widgets/InfoModal';
import { Document } from 'types';

interface RowProps {
  label: string;
  document?: Document<any> | null;
  clickHandler?: () => void;
}

const Row = ({ label, document, clickHandler }: RowProps) => {
  if (!document?.document_url) {
    return null;
  }

  return (
    <InfoModal.Row>
      <Label>{label}</Label>
      <InfoModal.RowDetails>
        <a
          href={document?.document_url}
          onClick={clickHandler}
          target="_blank"
          rel="noreferrer"
        >
          <ExternalLink to={document?.document_url || ''} onClick={clickHandler}>
            View application
          </ExternalLink>
        </a>
      </InfoModal.RowDetails>
    </InfoModal.Row>
  );
};

export default Row;
